/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 19.02.15.
 */

angular
  .module('farmnet.partner.externalAccounts')
  .directive(
    'settingsExternalAccount',
    function SettingsExternalAccountDirective() {
      'use strict';

      return {
        restrict: 'E',
        scope: {
          account: '='
        },
        templateUrl: require('./SettingsExternalAccountView.html'),
        controller: 'SettingsExternalAccountController'
      };
    }
  );
